/* eslint-disable @typescript-eslint/no-explicit-any */
import * as S from './HomePage.styles';
// import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
// import { LineRaceChart } from '@app/components/charts/LineRaceChart/LineRaceChart';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { BasicTableRow, getBasicTableData, Pagination } from 'api/table.api';
// import { BaseTable } from '@app/components/common/BaseTable/BaseTable';
// import { ColumnsType } from 'antd/es/table';
// import { useTranslation } from 'react-i18next';
import { useMounted } from '@app/hooks/useMounted';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
// import { FaRegWindowClose } from 'react-icons/fa';
import PopupModal from '@app/components/Model/PopupModal';
// import HomeImage from '@app/assets/Homepage.jpg';
import { getdashboardsetting } from '@app/api/dashboardsetting.api';
import { GlobalSpinner } from '@app/components/common/GlobalSpinner/GlobalSpinner';
import { themeObject } from '@app/styles/themes/themeVariables';
// import { BaseCard } from '@app/components/common/BaseCard/BaseCard';

export const cust = styled.div`
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px,
    rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;
  padding: 25px;
  margin: 15px;
  border-radius: 8px;
`;
const initialPagination: Pagination = {
  current: 1,
  pageSize: 5,
};
const HomePage: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [tableData, setTableData] = useState<{ data: BasicTableRow[]; pagination: Pagination; loading: boolean }>({
    data: [],
    pagination: initialPagination,
    loading: false,
  });
  const permissions = localStorage.getItem('permissions') && JSON.parse(localStorage.getItem('permissions') as string);
  const homePagePermission = permissions?.pagePermissions?.find((e: any) => e?.page_name === 'Home')?.permissions;
  const reportsPagePermission = permissions?.pagePermissions?.find((e: any) => e?.page_name === 'Reports')?.permissions;
  const retailPagePermission = permissions?.pagePermissions?.find(
    (e: any) => e?.page_name === 'Retail_Price_Audits',
  )?.permissions;
  const inMarketFootagePermission = permissions?.pagePermissions?.find(
    (e: any) => e?.page_name === 'In_Market_Footage',
  )?.permissions;

  // const { t } = useTranslation();
  const { isMounted } = useMounted();
  const Navigate = useNavigate();
  const [reportDetail, setReportDetail] = useState<any>();

  const fetchData = useCallback(async () => {
    try {
      const res = await getdashboardsetting();
      setReportDetail(res);
    } catch (err) {
      console.log('err', err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Memoize the reportDetail state to prevent re-renders when it hasn't changed
  const memoizedReportDetail = useMemo(() => reportDetail, [reportDetail]);
  const fetch = useCallback(
    (pagination: Pagination) => {
      setTableData((tableData) => ({ ...tableData, loading: true }));
      getBasicTableData(pagination).then((res) => {
        if (isMounted.current) {
          setTableData({ data: res.data, pagination: res.pagination, loading: false });
        }
      });
    },
    [isMounted],
  );

  useEffect(() => {
    fetch(initialPagination);
  }, [fetch]);

  // const handleTableChange = (pagination: Pagination) => {
  //   fetch(pagination);
  // };

  // const handleDeleteRow = (rowId: number) => {
  //   setTableData({
  //     ...tableData,
  //     data: tableData.data.filter((item) => item.key !== rowId),
  //     pagination: {
  //       ...tableData.pagination,
  //       total: tableData.pagination.total ? tableData.pagination.total - 1 : tableData.pagination.total,
  //     },
  //   });
  // };
  // const columns: ColumnsType<BasicTableRow> = [
  //   {
  //     title: t('common.name'),
  //     dataIndex: 'name',
  //     render: (text: string) => <span>{text}</span>,
  //     filterMode: 'tree',
  //     filterSearch: true,
  //     filters: [
  //       {
  //         text: t('common.firstName'),
  //         value: 'firstName',
  //         children: [
  //           {
  //             text: 'Joe',
  //             value: 'Joe',
  //           },
  //           {
  //             text: 'Pavel',
  //             value: 'Pavel',
  //           },
  //           {
  //             text: 'Jim',
  //             value: 'Jim',
  //           },
  //           {
  //             text: 'Josh',
  //             value: 'Josh',
  //           },
  //         ],
  //       },
  //       {
  //         text: t('common.lastName'),
  //         value: 'lastName',
  //         children: [
  //           {
  //             text: 'Green',
  //             value: 'Green',
  //           },
  //           {
  //             text: 'Black',
  //             value: 'Black',
  //           },
  //           {
  //             text: 'Brown',
  //             value: 'Brown',
  //           },
  //         ],
  //       },
  //     ],
  //     onFilter: (value, record) => record.name.includes(value.toString()),
  //   },
  //   {
  //     title: t('common.age'),
  //     dataIndex: 'age',
  //     sorter: (a: BasicTableRow, b: BasicTableRow) => a.age - b.age,
  //     showSorterTooltip: false,
  //   },
  //   {
  //     title: t('common.address'),
  //     dataIndex: 'address',
  //   },
  // ];
  const [open, setOpen] = useState(false);
  // function handleModal() {
  //   console.log('Clicked');
  //   setOpen(true);
  // }
  const desktopLayout = (
    <>
      <S.MainBox>
        <S.MainRow>
          {/* <S.LeftSideCol xl={24} xxl={14} id="desktop-content" style={{ padding: '0 30px 0 0' }}>
            <BaseRow gutter={[30, 30]} style={{ rowGap: '10px' }}>
              <BaseCol span={12}>
                <S.SubHead style={{ margin: '0' }}>Snapshot </S.SubHead>
              </BaseCol>
              <BaseCol span={12}>
                <S.Content style={{ margin: '0' }}> Avocado Weekly Exports FY22/23 vs FY2021/22</S.Content>
              </BaseCol>
              <BaseCol span={24}>
                <S.Divider />
              </BaseCol>

              <BaseCol sm={24} lg={12}>
                <S.Content style={{ marginTop: '30px' }}>
                  YTD Week Ending <S.MarkText> Sunday 3 December 2023</S.MarkText>
                </S.Content>

                <S.HomeTable
                  columns={columns}
                  dataSource={tableData.data}
                  pagination={tableData.pagination}
                  loading={tableData.loading}
                  onChange={handleTableChange}
                  scroll={{ x: 300 }}
                  bordered
                />
              </BaseCol>
              <BaseCol sm={24} lg={12}>
                <LineRaceChart />
              </BaseCol>
            </BaseRow>
          </S.LeftSideCol> */}
          <img
            src={memoizedReportDetail?.data[0]?.image}
            alt="HomeImage"
            width="100%"
            style={{ height: '350px', objectFit: 'cover' }}
          />
        </S.MainRow>
      </S.MainBox>

      <BaseCol span={24}>
        <S.MainRow>
          {reportsPagePermission?.show_page && (
            <S.LeftSideCol md={24} xl={8} xxl={8} id="desktop-content" style={{ marginTop: '20px' }}>
              <S.BaseCardBox>
                <S.SubHead>Reports </S.SubHead>
                <S.Content>
                  {' '}
                  Review DAFF and Avocados Australia reports to uncover the latest trends in Australia and export
                  markets.{' '}
                </S.Content>
                <S.GetStartedbutton onClick={() => Navigate('/dashboard/reports')}>Get Started</S.GetStartedbutton>
              </S.BaseCardBox>
            </S.LeftSideCol>
          )}
          {retailPagePermission?.show_page && (
            <S.LeftSideCol md={24} xl={8} xxl={8} id="desktop-content" style={{ marginTop: '20px' }}>
              <S.BaseCardBox>
                <S.SubHead>Retail Price Audits</S.SubHead>
                <S.Content>
                  {' '}
                  Analyse the competitive landscape in-market by reviewing competing products and their pricing, country
                  of origin, packaging and more.{' '}
                </S.Content>
                <S.GetStartedbutton onClick={() => Navigate('/dashboard/retail-price-audits')}>
                  Get Started
                </S.GetStartedbutton>
              </S.BaseCardBox>
            </S.LeftSideCol>
          )}
          {inMarketFootagePermission?.show_page && (
            <S.LeftSideCol md={24} xl={8} xxl={8} id="desktop-content" style={{ marginTop: '20px' }}>
              <S.BaseCardBox>
                <S.SubHead>In-Market Footage </S.SubHead>
                <S.Content>
                  {' '}
                  Explore what’s on the shelf in export markets with photos and videos straight from the store.{' '}
                </S.Content>
                <S.GetStartedbutton onClick={() => Navigate('/dashboard/in-market-footage')}>
                  Get Started
                </S.GetStartedbutton>
              </S.BaseCardBox>
            </S.LeftSideCol>
          )}
        </S.MainRow>
      </BaseCol>
    </>
  );

  //   const mobileAndTabletLayout = (
  //     <BaseRow gutter={[20, 24]}>
  //       <BaseCol span={24}>
  //         <TrendingCreators />
  //       </BaseCol>

  //       <BaseCol span={24}>
  //         <RecentlyAddedNft />
  //       </BaseCol>

  //       <BaseCol span={24}>
  //         <TrendingCollections />
  //       </BaseCol>

  //       <BaseCol span={24}>
  //         <RecentActivity />
  //       </BaseCol>
  //     </BaseRow>
  //   );
  return (
    <>
      {homePagePermission?.show_page && (
        <>
          {!memoizedReportDetail ? (
            <div style={{ textAlign: 'center' }}>
              <GlobalSpinner color={themeObject['light'].spinnerBase} />
            </div>
          ) : (
            <>
              <S.BlockWrapper>
                <S.ItemFlextext>
                  <S.Head>{memoizedReportDetail?.data[0]?.title}</S.Head>
                </S.ItemFlextext>

                <S.ItemFlextext>
                  <S.Description>{memoizedReportDetail?.data[0]?.description}</S.Description>
                </S.ItemFlextext>

                {/* <S.custdIV>
        <S.Item onClick={handleModal}>
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
            <path
              d="M10 5.04087C10 2.53706 7.98117 0.5 5.49972 0.5C3.0186 0.5 1 2.53706 1 5.04087C0.999779 6.46031 1.97051 8.11994 3.42307 9.27025C3.14994 9.43154 2.96564 9.7198 2.96564 10.0527C2.96564 10.2895 3.06191 10.5036 3.21583 10.6662C3.06195 10.8294 2.96564 11.0445 2.96564 11.2832C2.96564 11.7876 3.39181 12.198 3.91552 12.198H4.00523C4.08091 12.9278 4.72215 13.5 5.49966 13.5C6.27715 13.5 6.9187 12.9278 6.99409 12.198H7.08398C7.60792 12.198 8.0343 11.7876 8.0343 11.2793C8.0343 11.0425 7.93803 10.8285 7.78393 10.6658C7.93803 10.5026 8.0343 10.2875 8.0343 10.0488C8.0343 9.7184 7.84983 9.43099 7.5767 9.27008C9.02895 8.11977 10 6.46036 10 5.04092L10 5.04087ZM7.08404 9.7478C7.25642 9.7478 7.39671 9.88269 7.39671 10.0526C7.39671 10.2184 7.25642 10.3533 7.08404 10.3533L3.91562 10.3534C3.74345 10.3534 3.60339 10.2185 3.60339 10.0488C3.60339 9.88274 3.74345 9.74785 3.91562 9.74785L7.08404 9.7478ZM5.25021 9.13367L4.27522 4.8378C4.37468 4.88795 4.49711 4.92501 4.6544 4.92501C4.99386 4.92501 5.17665 4.75591 5.29737 4.64396C5.39643 4.55244 5.42233 4.53444 5.49823 4.53444C5.57497 4.53444 5.6011 4.55244 5.70077 4.64439C5.8217 4.75617 6.00471 4.92505 6.34395 4.92505C6.50187 4.92505 6.62496 4.88778 6.72464 4.83746L5.74948 9.13376L5.25021 9.13367ZM5.49974 12.8858C5.07464 12.8858 4.72225 12.588 4.6506 12.198H6.34908C6.27743 12.588 5.92504 12.8858 5.49972 12.8858H5.49974ZM7.08406 11.5839H3.91565C3.74347 11.5839 3.60342 11.449 3.60342 11.2793C3.60342 11.1135 3.74347 10.9786 3.91565 10.9786H7.08417C7.25656 10.9786 7.39684 11.1135 7.39684 11.2832C7.3968 11.4488 7.25652 11.5839 7.08413 11.5839H7.08406ZM6.70342 9.13367H6.40222L7.50111 4.29288C7.50133 4.29229 7.50111 4.29165 7.50133 4.29105C7.50324 4.28265 7.50324 4.27407 7.50452 4.26567C7.5062 4.25318 7.50833 4.24068 7.50833 4.2284C7.50833 4.22819 7.50855 4.2278 7.50855 4.22737C7.50855 4.22247 7.50727 4.21774 7.50705 4.21283C7.5062 4.19769 7.50536 4.18255 7.50235 4.1678C7.50067 4.15961 7.49766 4.15202 7.49536 4.14404C7.49195 4.13299 7.4892 4.12174 7.48451 4.11086C7.4807 4.10207 7.47556 4.09389 7.47113 4.08548C7.46626 4.07649 7.46179 4.06727 7.45603 4.05866C7.45072 4.0509 7.44412 4.0439 7.43797 4.03674C7.43137 4.02855 7.42499 4.02015 7.41733 4.0126C7.41096 4.00625 7.40329 4.00074 7.39608 3.99499C7.38757 3.98803 7.37969 3.98087 7.37035 3.97473C7.36163 3.9688 7.35184 3.96449 7.3425 3.95937C7.33377 3.95485 7.32571 3.94974 7.31655 3.94586C7.30357 3.94052 7.28998 3.93707 7.27661 3.93315C7.27023 3.93131 7.2643 3.92863 7.25792 3.92722C7.25748 3.92722 7.25686 3.92722 7.25641 3.927C7.24411 3.92453 7.23135 3.92393 7.2186 3.92291C7.20965 3.9221 7.20075 3.92044 7.19203 3.92027C7.19119 3.92027 7.19052 3.92005 7.18968 3.92005C6.84983 3.92005 6.66704 4.08915 6.5461 4.20094C6.44665 4.29263 6.42048 4.31067 6.34419 4.31067C6.26789 4.31067 6.24172 4.29268 6.14227 4.20094C6.02134 4.08916 5.83833 3.92005 5.49846 3.92005C5.15922 3.92005 4.97666 4.08915 4.85572 4.2011C4.75667 4.29279 4.73077 4.31084 4.65464 4.31084C4.57875 4.31084 4.55284 4.29284 4.45378 4.20132C4.33285 4.08932 4.15006 3.92027 3.8106 3.92027C3.80998 3.92027 3.80954 3.92048 3.80892 3.92048C3.79873 3.92048 3.78828 3.92232 3.77787 3.92356C3.76663 3.92458 3.75511 3.92501 3.74409 3.92722C3.74364 3.92722 3.74325 3.92722 3.74258 3.92744C3.73621 3.92867 3.73067 3.93153 3.72451 3.93315C3.7107 3.93682 3.69666 3.94053 3.68369 3.94603C3.67496 3.9497 3.66713 3.95465 3.65902 3.95891C3.64924 3.96403 3.63905 3.96872 3.62971 3.97486C3.62121 3.98058 3.61377 3.98736 3.60588 3.99388C3.598 4.00024 3.58994 4.00616 3.58295 4.01312C3.57613 4.01985 3.57042 4.02766 3.56426 4.03504C3.55744 4.04301 3.55044 4.0506 3.54451 4.05918C3.53942 4.06677 3.53557 4.07495 3.53114 4.08293C3.52582 4.09236 3.52007 4.10135 3.51582 4.11138C3.51201 4.12059 3.50966 4.1304 3.50669 4.14004C3.50373 4.14946 3.5001 4.15846 3.49819 4.16827C3.49562 4.18076 3.495 4.19343 3.49416 4.20635C3.49372 4.21352 3.49204 4.22026 3.49204 4.22742C3.49204 4.22802 3.49226 4.22845 3.49226 4.22904C3.49226 4.23885 3.49416 4.2487 3.49545 4.25873C3.49651 4.26977 3.49695 4.28082 3.49926 4.29169C3.49926 4.29212 3.49926 4.2925 3.49948 4.29314L4.59814 9.13393H4.29655C2.7519 8.11549 1.63814 6.40816 1.63836 5.04113C1.63836 2.87589 3.37085 1.11439 5.50043 1.11439C7.63035 1.11439 9.36306 2.87589 9.36306 5.04113C9.36244 6.40794 8.24846 8.11518 6.70341 9.1336L6.70342 9.13367Z"
              fill="#1D4247"
              stroke="#1D4247"
              strokeWidth="0.2"
            />
          </svg>
          <S.Content style={{ marginBottom: '10px', marginLeft: '5px' }}>Guided Tour</S.Content>
        </S.Item>
        <S.Item>
          <S.Content style={{ marginBottom: '0px' }}>New to the portal? Take a look around here.</S.Content>
        </S.Item>
        <FaRegWindowClose style={{ position: 'absolute', top: ' 20%', right: '4%' }} />
      </S.custdIV> */}
              </S.BlockWrapper>
              <PopupModal
                open={open}
                setIsModalOpen={setOpen}
                content={
                  <div>
                    <iframe
                      width={'100%'}
                      height={320}
                      src="https://www.youtube.com/embed/2PRddAm9730?si=O9Mg_x6MQDwJ6ghI"
                      title="YouTube video player"
                      frameBorder={0}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  </div>
                }
              />
              {desktopLayout}
              {/* {isDesktop ? desktopLayout : mobileAndTabletLayout} */}
            </>
          )}
        </>
      )}
    </>
  );
};

export default HomePage;
